export default "<div [@fadeInAnimation]=\"getAnimationData(routerOutlet)\">\n    <router-outlet #routerOutlet=\"outlet\"></router-outlet>\n</div>"